import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Provider } from '@angular/core';
import { MockApiInterceptor } from '@bca-core/interceptors/mock-api.interceptor';
import { NotificationInterceptor } from '@bca-core/interceptors/notification.interceptor';
import { environment } from '@environments/environment';

export function provideInterceptors(): Provider[] {
  return [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NotificationInterceptor,
      multi: true
    },
    !environment.production && environment.api.mock
      ? {
          provide: HTTP_INTERCEPTORS,
          useClass: MockApiInterceptor,
          multi: true
        }
      : []
  ];
}
